import { formatShortDate } from "@clipboard-health/date-time";
import { PromotionBanner } from "@clipboard-health/ui-components";

interface UnverifiedShiftBannerProps {
  workplaceName: string;
  shiftDate: Date;
  ctaButtonText: string;
  isLoading?: boolean;
  onCtaClick: () => void;
}

export function UnverifiedShiftBanner(props: UnverifiedShiftBannerProps) {
  const { workplaceName, shiftDate, ctaButtonText, isLoading = false, onCtaClick } = props;

  const formattedDate = formatShortDate(shiftDate);

  return (
    <PromotionBanner
      title={`You forgot to clock out on ${formattedDate}.`}
      subtitle={`Please submit your timesheet for your shift at ${workplaceName} to get paid.`}
      icon="clock-error-with-exclamation-colored"
      borderVariant="none"
      backgroundColor={(theme) => theme.palette.intent!.error.gradient!}
      titleColor={(theme) => theme.palette.intent!.error.text}
      ctaButtonText={ctaButtonText}
      ctaButtonVariant="outlined"
      ctaButtonIsLoading={isLoading}
      sx={(theme) => ({
        width: "100%",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.08)",
        alignItems: "stretch",
        "& *": {
          whiteSpace: "normal",
          wordWrap: "break-word",
        },
        "& .MuiCardContent-root": {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
        },
        "& .MuiCardContent-root > .MuiButton-root": {
          marginTop: "auto",
        },
        "& .MuiCardContent-root > .MuiStack-root > .MuiStack-root:first-of-type": {
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          columnGap: theme.spacing(4),
          rowGap: theme.spacing(3),
          alignItems: "center",
        },
        "& .MuiCardContent-root > .MuiStack-root > .MuiStack-root:first-of-type > .MuiStack-root": {
          display: "contents",
        },
        "& .MuiTypography-body1": {
          fontSize: theme.typography.h6.fontSize,
          lineHeight: theme.typography.h6.lineHeight,
        },
        "& .MuiTypography-body2": {
          gridColumn: "1 / -1",
        },
      })}
      onClick={onCtaClick}
    />
  );
}
